var React = require('react');

function Unlock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 3a9 9 0 00-9 9v7.5a1.5 1.5 0 01-3 0V12a12 12 0 1124 0v7.5a1.5 1.5 0 01-3 0V12a9 9 0 00-9-9z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 19.5a1.5 1.5 0 011.5-1.5h33a1.5 1.5 0 011.5 1.5v27a1.5 1.5 0 01-1.5 1.5h-33a1.5 1.5 0 01-1.5-1.5v-27zm3 1.5v24h30V21H15z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M29.998 30a2.247 2.247 0 012.252 2.252A2.25 2.25 0 1129.998 30zM30 31.5V30h-.004L30 31.5zm.75.75l1.5.004v-.004h-1.5z","key":2})]);
}

Unlock.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Unlock;

Unlock.default = Unlock;
